import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import MembershipEdit from './MembershipEdit';

const Membership = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
                <p></p>
                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="membership" 
                        value={data.membership} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="memebr level" 
                        value={data.mem_level} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="since date" 
                        value={data.since_date ? data.since_date.format('DD-MM-YYYY') : null} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="expiry date" 
                        value={data.expiry_date ? data.expiry_date.format('DD-MM-YYYY') : null} 
                    />
                </Row>  
                <p></p>
            </div>
            
            );
        })
           
        :
        <>
            <p></p>
            <MembershipEdit data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Membership